import "./App.css";
import { useEffect, useState, createContext } from "react";
import NavBar from "./components/NavBar";
import InfoPage from "./routes/InfoPage";
import Filters from "./components/Filters";
import MapContainer from "./components/MapContainer";
import { convertFiltersToMapbox } from "./utils";
import FontFaceObserver from "fontfaceobserver";
import AddToHome from "./components/AddToHome";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet-async";
import UseSpaceListFetch from "./hooks/UseSpaceListFetch";
import useFilters from "./hooks/UseFilters";
import LandscapeModeWarning from './components/LandscapeModeWarning'
import { OrientationProvider } from './contexts/OrientationContext'

function App() {
  //DATA
  const [filters, setFilters] = useState({});
  const [mapFilters, setMapFilters] = useState({});
  //space data
  const { spaces, loading } = UseSpaceListFetch();

  //filtered spaces
  const { filteredSpaces } = useFilters({ spaces, filters });

  //NAVIGATION
  const [filterPage, setFilterPage] = useState(false);
  const [mapPage, setMapPage] = useState(true);
  const [infoPage, setInfoPage] = useState(false);

  const [mapWarning, setMapWarning] = useState(false);
  const [mapTitleClicked, mapTitleClick] = useState(0);

  const [triggerWebViewWarning, setTriggerWebViewWarning] = useState(false);

  const [isLoaded, setIsLoaded] = useState(false);
  const showFilters = () => {
    setFilterPage(true);
    setMapPage(false);
    setInfoPage(false);
  };
  const showMap = () => {
    mapTitleClick(Date.now());

    setFilterPage(false);
    setMapPage(true);
    setInfoPage(false);
    setMapWarning(false);
  };
  const showInfo = () => {
    setFilterPage(false);
    setMapPage(false);
    setInfoPage(true);
  };

  const [warningDismissed, setWarningDismissed] = useState(false);
  const isWebView = () => {
    return (
      (window.navigator &&
        window.navigator.userAgent &&
        window.navigator.userAgent.includes("FB_IAB")) ||
      window.navigator.userAgent.includes("FBAV") ||
      window.navigator.userAgent.includes("Instagram")
    );
  };


  //ORIENTATION
  const [isLandscapeMode, setIsLandscapeMode] = useState(isMobile && window.innerWidth > window.innerHeight);
  window.addEventListener('resize', () => {
    if (isMobile && window.innerWidth > window.innerHeight) {
      setIsLandscapeMode(true);
    } else {
      setIsLandscapeMode(false)
    }
  })

  useEffect(() => {
    Promise.all([
      new FontFaceObserver("SyneBold").load(),
      new FontFaceObserver("SyneItalic").load(),
      new FontFaceObserver("Syne").load(),
    ]).then(() => {
      setIsLoaded(true);
    });

    setTimeout(() => {
      setTriggerWebViewWarning(isWebView());
    }, 1000);

    if (isWebView() && window.navigator.userAgent.includes("Android")) {
      window.location.assign(
        `intent://${window.location.host}#Intent;scheme=http;action=android.intent.action.VIEW;end;`
      );
      window.stop();
    } else if (
      window.navigator.userAgent.includes("Safari") ||
      window.navigator.userAgent.includes("AppleWebKit")
    ) {
      // window.open(
      //   `https://iphone-troubleshooting--camposmagneticos.netlify.app/`,
      //   "_blank"
      // );
      // window.stop();
    }
  }, []);

  //hack for ios... but still doesn't solve all problems
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1000);
  }, []);

  return (
    isLoaded && (
      <div className="app">
        <LandscapeModeWarning isLandscapeMode={isLandscapeMode} />
        {/* TODO: Turn this into component */}
        {triggerWebViewWarning && !warningDismissed && (
          <div className="webViewWarning">
            <div className="message">
              <div>Para uma melhor experiência </div>
              <div>abrir este link no navegador.</div>
            </div>
            <div className="warningIconContainer">
              <div className="warningIcon" />
              <div
                onClick={() => {
                  setWarningDismissed(true);
                }}
                className="closingIcon"
              />
            </div>
          </div>
        )}
        <Helmet>
          <title>Campos Magnéticos</title>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta
            name="description"
            content="Campos Magnéticos é um arquivo-vivo que procura identificar, documentar e divulgar uma rede informal de espaços geridos por artistas no Porto, a partir dos anos 90."
            data-rh="true"
          />
          <meta name="robots" content="index, follow" />
          <meta name="theme-color" content="#000000" />
          <link rel="canonical" href="https://camposmagneticos.netlify.app/" />
        </Helmet>
        {isMobile && <AddToHome />}
        <NavBar
          mapWarning={mapWarning}
          showFilters={() => showFilters}
          showMap={() => showMap}
          showInfo={() => showInfo}
        />
        <div className="content">
          <div className={filterPage ? "" : "hidden"}>
            <Filters
              setFilters={(filters) => {
                setFilters(filters);
                setMapFilters(convertFiltersToMapbox(filters));
                !mapPage && setMapWarning(true);
              }}
            />
          </div>



          <div style={{ overflow: 'hidden' }} className={mapPage ? "" : "hidden"}>
            <OrientationProvider value={isLandscapeMode}>
              <MapContainer
                mapTitleClicked={mapTitleClicked}
                spaceList={filteredSpaces}
                mapFilters={mapFilters}
                hidden={mapPage}
              />
            </OrientationProvider>
          </div>
          <div className={infoPage ? "" : "hidden"}>
            <InfoPage />
          </div>
        </div>
      </div>
    )
  );
}

export default App;
